/* eslint-disable react/prop-types, require-jsdoc */
import React, { Fragment } from 'react';
import styled from 'styled-components';

import Styles from './ShuttleForm.Styles';
import ValidateButton from '../TicketsWhite/ValidateButton';
import Text from '../../base/Text';

import { PINK } from '../../../constants/colors';

import TicketInfo from '../TicketInfo';
import InputsField from '../../base/InputsFieldFlat';
import gettingData from '../../../assets/images/clock.gif';
import { getParkingStatus } from '../../../helpers/CartManager';
import purple_arrow from "../../../assets/images/purple_arrow.png"
import { number } from 'prop-types';

const Column = styled.div`${Styles.column}`;
const Row = styled.div`${Styles.row}`;
const Select = styled.select`${Styles.inputRounderSelect}`;
const InputsWrapper = styled.div`${Styles.inputsWrapper};`;
const LabelInput = styled(Text).attrs({ bold: true })`${Styles.labelInput}`;
const Info = styled(Text).attrs({ bold: true, tag: 'h4' })`${Styles.info}`; // prettier-ignore
const AddPlacesContainer = styled.div`${Styles.addPlacesConatiner}`;
const RounderComponent = styled.div`${Styles.rounderComponent}`;
const Increment = styled.div`${Styles.increment}`;
const Decrement = styled.div`${Styles.increment}`;
const PurplePrice = styled(Text).attrs({ bold: true, tag: 'h4' })`${Styles.purplePrice}`; // prettier-ignore
const PurpleUsd = styled(Text).attrs({ bold: true, tag: 'h4' })`${Styles.purpleUsd}`; // prettier-ignore
const PurpleTotal = styled(Text).attrs({ bold: true, tag: 'h4' })`${Styles.purpleUsd}`; // prettier-ignore
const PriceContainer = styled.div`${Styles.priceContainer}`;
const ButtonContainer = styled.div`${Styles.buttonContainer}`;
const Banner = styled.img`${Styles.banner}`;
const PinkBannerTitle = styled(Text).attrs({ bold: true, tag: 'h4' })`${Styles.pinkBannerTitle}`;
const PinkBannerText = styled(Text).attrs({ bold: true, tag: 'h4' })`${Styles.pinkBannerText}`; // prettier-ignore


// eslint-disable-next-line require-jsdoc
const Item = ({
  n, vehicleInfo, onVehicleUpdate, translations, counterParking
}) => {
  const {
    brand, model, year, color, license, state
  } = vehicleInfo;
  return (
    <div style={{ marginTop: 5 }}>
      <Info className="col-12">{translations.passengerInformation}</Info>
      <Column style={{ flex: 9 }}>
        <Row style={{ justifyContent: 'flex-start', margin: 0 }}>
          <InputsWrapper style={{ flex: 2 }}>
            <LabelInput>{translations.passenger} {counterParking}</LabelInput>
            <InputsField
              value={brand}
              onChange={e => onVehicleUpdate(n, 'brand', e.target.value)}
            />
          </InputsWrapper>
          <InputsWrapper style={{ flex: 2 }}>
            <LabelInput> </LabelInput>
            <InputsField value={model} onChange={e => onVehicleUpdate(n, 'model', e.target.value)} />
          </InputsWrapper>
        </Row>
        <Row style={{ justifyContent: 'flex-start', margin: '15px 0px', width: "70%" }}>
          <InputsWrapper style={{ flex: .5 }}>
            <LabelInput>{translations.travelPurpose}</LabelInput>
            <InputsField value={color} onChange={(e) => { onVehicleUpdate(n, 'color', e.target.value); }} />
          </InputsWrapper>
          <InputsWrapper style={{ flex: 1 }}>
            <LabelInput>{translations.shoppingLabels.type}</LabelInput>
            <InputsField value={state} onChange={(e) => { onVehicleUpdate(n, 'state', e.target.value); }} />
          </InputsWrapper>
        </Row>
      </Column>
    </div>);
};

/**
* TicketInfo component
* @returns {JSX.Element}
*/
const ShuttleForm = ({
  translations,
  ticketType,
  startDate,
  startDateHandler,
  endDate,
  endDateHandler,
  startTime,
  startTimeHandler,
  endTime,
  endTimeHandler,
  lot,
  locale,
  lotHandler,
  saveParkingInfo,
  increment,
  decrement,
  counterParking,
  initializeCounter,
  onVehicleUpdate,
  callParkingApi,
  getParkingPrice,
  isCallingParkingApi,
  minDate,
  maxDate,
  openShuttleSelectSeats
}) => {
  const sim = '<';

  let lotInfo = { price: 0 };
  let cars = [];
  let parkingData = [];
  let parkingLots = [];
  if (typeof window !== 'undefined') {
    parkingData = JSON.parse(window.localStorage.getItem('parking'));
    parkingLots = JSON.parse(window.localStorage.getItem('CBX_Parking_Lots'));
    if (!parkingLots) {
      parkingLots = [];
    }
  }

  const openLot = () => {
    window.location.href = `/${locale}/lot`;
  };

  if (parkingData) {
    const { data, vehicles } = parkingData;
    if (data) {
      lotInfo = data;
    }
    if (vehicles) {
      if (vehicles.length > 0) {
        cars = [...vehicles];
        initializeCounter(vehicles.length > counterParking ? vehicles.length : counterParking);
      }
    }
  }

  const generateRows = (counter, vInfo) => {
    const rows = [];
    for (let i = 0; i < counter; i += 1) {
      const vehicleInfo = typeof vInfo[i] !== 'undefined'
        ? vInfo[i]
        : {
          brand: '', model: '', year: '', color: '', license: '', state: ''
        };
      rows.push(
        <Item
          key={i}
          n={i}
          counterParking={counter}
          translations={translations}
          vehicleInfo={vehicleInfo}
          onVehicleUpdate={onVehicleUpdate}
        />
      );
    }
    return rows;
  };

  const validCar = (car) => {
    const minYear = 1900;
    const maxYear = new Date().getFullYear() + 1;
    return !!(car.brand && car.model && (car.year && car.year >= minYear && car.year <= maxYear) && car.color && car.license && car.state);
  };

  const checkVehicles = () => {
    const ValidVehicles = cars
      .map((validCar))
      .filter((isValidCar) => {
        return isValidCar;
      });
    return cars.length > 0 && ValidVehicles.length === counterParking;
  };

  const createTimesArray = (step) => {
    const d = new Date(1970, 0, 1);
    const t = [];
    while (d.getDate() === 1) {
      const v = d.toTimeString().slice(0, 5);
      t.push({ name: v, value: v });
      d.setMinutes(d.getMinutes() + step);
    }
    return t;
  };


  const timeStep = 30;
  const getStartTimeOptions = () => {
    const d = new Date();
    const h = d.getHours();
    const m = d.getMinutes();
    const t = createTimesArray(timeStep);
    const filtered = t.filter((o) => {
      const optH = parseInt(o.value.split(':')[0], 10);
      const optM = parseInt(o.value.split(':')[1], 10);
      return (m < timeStep ? optH >= h : optH > h) && (m < timeStep && h === optH ? optM === timeStep : 1);
    });
    return new Date(`${startDate}T00:00:00.000`).getTime() > Date.now() ? createTimesArray(timeStep) : filtered;
  };

  const homepageImage = {
    position: 'relative',
    textAlign: 'center',
    height: '250px',
    backgroundSize: 'contain',
    backgroundRepeat: "round",
    zIndex: 1,
    backgroundImage: `linear-gradient(
        70deg,
        #3F2A55,
        #3F2A55,
        #3F2A55,
          transparent
          ), url(https://mexico-now.com/wp-content/uploads/2021/10/Cross-Border-Xpress.jpg)`
  };


  return (
    <Fragment>
      <PurpleUsd>
        <img
          alt=""
          width="30px"
          height="20px"
          style={{ marginInline: 'auto', cursor: 'pointer', paddingRight: '10px' }}
          src={purple_arrow}
          locale={locale}
          onClick={openLot}
        />
        {translations.shuttleSelectDatesLabel}
      </PurpleUsd>
      <Info className="col-12">{getParkingStatus() && translations.shuttleSelectDatesLabel}</Info>
      {/* <div style={{
        position: "relative", marginBottom: "50px",
        marginTop: "50px"
      }}>
        <div style={{ width: "90%", padding: "30px 40px", position: "absolute", zIndex: 2 }}>
          <PinkBannerTitle>Sacramento</PinkBannerTitle>
          <p style={{ color: "#D8D8D8", width: "400px", fontWeight: "bold" }}>6201 Franklin Blvd.</p>
          <div style={{ display: "flex", justifyContent: "space-between", width: "450px" }}>
            <div style={{ display: 'flex', textAlign: "center" }}><PinkBannerTitle></PinkBannerTitle></div>
            <div style={{ display: 'flex', textAlign: "start", marginTop: "5px" }}>
              <p style={{ color: "white"}}>{translations.shuttleFormDescription}
              </p>
            </div>
          </div>
          <PinkBannerTitle>$80 USD</PinkBannerTitle>
        </div>
        <div style={homepageImage} />
      </div> */}
      <Fragment>
        {/* <Info className="col-12" style={{ width: 'auto' }}>{translations.selecDateLabel}</Info> */}
        <Row style={{ justifyContent: 'flex-start' }}>
          {/* <InputsWrapper style={{ flex: .2 }}>
            <LabelInput>{translations.departDate}</LabelInput>
            <Select onChange={startTimeHandler} value={startTime} >
              <option value="" disabled>--:--</option>
              {getStartTimeOptions().map(option => (
                <option value={option.value} key={`inputValue${name}${option.value}`}>
                  {option.name}
                </option>
              ))}
            </Select>
          </InputsWrapper> */}
          {/* <AddPlacesContainer style={{ flex: .2 }}>
            <LabelInput>{translations.numberOfTickets}</LabelInput>
            <RounderComponent>
              <Decrement onClick={decrement}>
                <Info>-</Info>
              </Decrement>
              <h3 style={{ color: PINK }} id="c">{counterParking}</h3>
              <Increment
                style={{ marginLeft: '8px' }}
                onClick={increment}
              >
                <Info>+</Info>
              </Increment>
            </RounderComponent>
          </AddPlacesContainer> */}
        </Row>
        {generateRows(counterParking, cars)}
        <PriceContainer>
          <PurpleUsd>Total:</PurpleUsd>
          <div style={{ display: 'flex' }}><PurplePrice>{`$${lotInfo.price > 0 ? (lotInfo.price.toFixed(2) * counterParking).toFixed(2) : 0}`}</PurplePrice><PurpleUsd>USD</PurpleUsd></div>
          <Row>
            <ButtonContainer>
              <ValidateButton
                disabled={!checkVehicles()}
                message={translations.editParking}
                backgroundColor="#D8D8D8"
                textColor="#726C79"
              />
            </ButtonContainer>
            <ButtonContainer>
              <ValidateButton
                disabled={!checkVehicles()}
                message={translations.continueParking}
                backgroundColor="#3F2A55"
                textColor="white"
              />
            </ButtonContainer>
            <ButtonContainer>
              <ValidateButton
                // disabled={!startDate || !endDate || !startTime || !endTime || !checkVehicles()}
                action={openShuttleSelectSeats}
                message={translations.continueLabel}
              />
            </ButtonContainer>
          </Row>
        </PriceContainer>
      </Fragment>
      {isCallingParkingApi && (
        <div
          style={{
            padding: '5%',
            width: '100%',
            margin: 'auto',
            justifyContent: 'center'
          }}
        >
          <img
            alt=""
            style={{ margin: 'auto', display: 'block ' }}
            width="150px"
            height="auto"
            src={gettingData}
          />
        </div>
      )}
    </Fragment>
  );
};


export default ShuttleForm;
